/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'


interface ButtonGroupProps {
  direction: 'vertical' | 'horizontal';
  buttons: any[];
  activeButtonId?: number;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ direction, buttons, activeButtonId }) => {
  const [activeButton, setActiveButton] = useState<number | null>(null)

  useEffect(() => {
    if (activeButtonId) {
      setActiveButton(activeButtonId)
    }
  }, [activeButtonId])

  const handleClick = (button: any) => {
    setActiveButton(button.id)
    button.onClick()
  }

  const containerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: direction === 'vertical' ? 'column' : 'row',
    background: 'var(--white, #fff)',
    padding: '5px',
  }

  return (
    <div style={containerStyle}>
      {buttons &&
        buttons.map((button, index) => (
          <button
            key={index}
            onClick={() => handleClick(button)}
            style={
              activeButton === button.id
                ? { backgroundColor: '#7e92a252', color: 'white' }
                : {}
            }
          >
            {button.icon}
            {button.text}
          </button>
        ))}
    </div>
  )
}

export default ButtonGroup
